module.exports = __webpack_public_path__ + "img/qrcode_frame_2.b05776f3.png";